exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card--event[data-v-1dbd9b1d], .card--event *[data-v-1dbd9b1d] {\n  color: #000000;\n}\n.card--event .card__thumbnail[data-v-1dbd9b1d] {\n  width: 100%;\n  height: auto;\n  border-radius: 1rem;\n  overflow: hidden;\n  display: block;\n  line-height: 0;\n}\n.card--event .card__thumbnail img[data-v-1dbd9b1d] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  max-width: initial;\n}", ""]);

// exports
